import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const flagStyle = { width: 20, height: 15, objectFit: "cover", marginRight: 8, verticalAlign: "middle" };

const LanguageSelect = ({ languages, value, onChange, disabled, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selected = languages.find(
    (l) => `${l.text}_${l.lang}` === value
  );

  return (
    <Dropdown
      id={id}
      isOpen={isOpen}
      toggle={() => setIsOpen((prev) => !prev)}
      className="language-select-dropdown"
    >
      <DropdownToggle caret className="language-select-toggle" disabled={disabled}>
        {selected ? (
          <>
            <img src={`/images/flags/${selected.lang}.svg`} alt="" style={flagStyle} />
            {selected.text}
          </>
        ) : value}
      </DropdownToggle>
      <DropdownMenu className="language-select-menu">
        {languages.map((l) => {
          const optionValue = `${l.text}_${l.lang}`;
          return (
            <DropdownItem
              key={optionValue}
              active={optionValue === value}
              onClick={() => onChange(optionValue)}
            >
              <img src={`/images/flags/${l.lang}.svg`} alt="" style={flagStyle} />
              {l.text}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

LanguageSelect.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      lang: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default LanguageSelect;
